(function(){
  if(window.__PRH_LOADED__){ if(window.__PRH_SCAN__) window.__PRH_SCAN__(); return; }
  window.__PRH_LOADED__=true;
  var cl=function(x,a,b){return Math.max(a===undefined?0:a,Math.min(b===undefined?1:b,x));};
  var eOC=function(t){return 1-Math.pow(1-t,3);};
  function rgb(h){h=(h||'#3a4150').replace('#','');if(h.length===3)h=h.split('').map(function(c){return c+c}).join('');var n=parseInt(h,16);return [(n>>16)&255,(n>>8)&255,n&255];}

  function Rail(root){
    var self=this;
    var stage=root.querySelector('.prh__stage'), track=root.querySelector('.prh__track'), rail=root.querySelector('.prh__rail');
    var head=root.querySelector('.prh__head'), info=root.querySelector('.prh__info');
    var els=[].slice.call(root.querySelectorAll('.prh__item'));
    if(!els.length) return;
    var calls=[].slice.call(root.querySelectorAll('.prh__call')).map(function(c){return {el:c,line:c.querySelector('.prh__line'),dot:c.querySelector('.prh__dot'),chip:c.querySelector('.prh__chip'),txt:c.querySelector('.prh__chip span')};});
    var cone=root.querySelector('.prh__cone'), glow=root.querySelector('.prh__glow'), water=root.querySelector('.prh__water');
    var ckTxt=root.querySelector('.prh__ckt'), t1=root.querySelector('.prh__t1'), t2=root.querySelector('.prh__t2'), shop=root.querySelector('.prh__shop'), mchips=root.querySelector('.prh__mchips'), mcta=root.querySelector('.prh__mcta');
    var dotsWrap=root.querySelector('.prh__dots');
    var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var AUTO=root.getAttribute('data-autoplay')==='true'&&!RM;
    var INT=(parseFloat(root.getAttribute('data-interval'))||3.2)*1000;
    root.style.setProperty('--int',(INT/1000)+'s');
    var items=els.map(function(el,i){
      var img=el.querySelector('img');
      return {el:el,i:i,sw:el.querySelector('.prh__swing'),img:img,label:el.getAttribute('data-label')||'',sub:el.getAttribute('data-sub')||'',
        specs:(el.getAttribute('data-specs')||'').split('|').filter(function(s){return s.trim().length}),accent:el.getAttribute('data-accent')||'#38E1FF',glow:rgb(el.getAttribute('data-glow')),
        url:el.getAttribute('href'),ar:1.2,f:0,fv:0,a:0,av:0,x:0,dropAt:0,landed:false,featT:-10,lastF:'',lastT:''};
    });
    items.forEach(function(it){
      function setAr(){ if(it.img&&it.img.naturalWidth) it.ar=it.img.naturalHeight/it.img.naturalWidth; }
      if(!it.img) return;
      if(it.img.complete) setAr(); else it.img.addEventListener('load',function(){setAr();layout();});
    });
    if(dotsWrap){dotsWrap.innerHTML='';items.forEach(function(it,i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Show '+(it.label+' '+it.sub).trim()+' '+(i+1));b.innerHTML='<i></i>';
      b.addEventListener('click',function(){manual(i,6000);});dotsWrap.appendChild(b);it.dot=b;});}

    var W=0,H=0,mobile=false,gw=170,sp=120,railY=200,S=1.5,hookOff=30,infoH=140;
    var cur=-1,hover=-1,shown=-1,camX=0,camInit=false,last=0,raf=0,visible=false,revealed=false,lastTour=0,pauseUntil=0,editorHold=false;
    var glowC=[58,65,80],mx=-1,my=-1,pmx=-1,mvx=0,callTimer=0,infoTimer=0;

    function layout(){
      var r=root.getBoundingClientRect();W=r.width;H=r.height;mobile=W<900;
      var hb=head.getBoundingClientRect();
      railY=Math.round(hb.bottom-r.top+(mobile?30:38));
      var n=items.length;
      infoH=info.getBoundingClientRect().height+(mobile?34:40);
      if(mobile){gw=Math.round(cl(W*0.34,110,190));sp=Math.round(gw*1.04);}
      else{var avail=W-120;sp=Math.min(260,avail/Math.max(1.2,n+0.4));gw=Math.round(cl(sp*1.42,130,220));}
      root.style.setProperty('--gw',gw+'px');
      hookOff=gw*0.18;
      var arAvg=items.reduce(function(s,it){return s+it.ar},0)/n;
      var room=H-railY-infoH-(mobile?6:16);
      S=cl(room/(hookOff+gw*arAvg),1.15,mobile?1.75:1.9);
      rail.style.top=railY+'px';
      items.forEach(function(it,i){it.x=mobile? i*sp : W/2+(i-(n-1)/2)*sp;});
      if(!camInit&&mobile){camX=items[0].x;camInit=true;}
      if(water) water.style.top=(railY+gw*0.25)+'px';
    }

    function edgeShift(it){ if(mobile) return 0; var half=gw*S/2, m=18; return Math.max(0,m-(it.x-half))-Math.max(0,(it.x+half)-(W-m)); }
    function setActive(i){
      if(i===shown) return;
      var prev=shown;shown=i;
      items.forEach(function(it,k){it.el.classList.toggle('is-feat',k===i);});
      if(i>=0){var it=items[i];it.featT=now();it.av+=(i%2?1:-1)*(RM?0:55);root.style.setProperty('--prh-accent',it.accent);}
      items.forEach(function(it,k){if(!it.dot)return;it.dot.classList.toggle('on',k===i);it.dot.classList.remove('run');});
      if(i>=0&&items[i].dot&&AUTO&&hover<0&&!editorHold){void items[i].dot.offsetWidth;items[i].dot.classList.add('run');}
      calls.forEach(function(c){c.el.classList.remove('on');});
      clearTimeout(callTimer);
      if(i>=0) callTimer=setTimeout(function(){
        var it=items[i];
        calls.forEach(function(c,k){var s=it.specs[k];if(!s){c.el.style.display='none';return;}c.el.style.display='';c.txt.textContent=s;c.el.style.setProperty('--a',it.accent);
          c.line.style.background='linear-gradient(90deg,'+it.accent+',rgba(255,255,255,.85))';
          c.line.style.transitionDelay=(k*0.1)+'s';c.dot.style.transitionDelay=(k*0.1)+'s';c.chip.style.transitionDelay=(0.12+k*0.1)+'s';
          c.w=c.chip.offsetWidth;c.h=c.chip.offsetHeight;c.el.classList.add('on');});
      },RM?0:330);
      if(mchips) mchips.classList.remove('on');
      info.classList.add('swap');clearTimeout(infoTimer);
      infoTimer=setTimeout(function(){
        if(i<0) return;
        var it=items[i];
        if(ckTxt) ckTxt.textContent=('0'+(i+1)).slice(-2)+' / '+('0'+items.length).slice(-2);
        t1.textContent=it.label;t2.textContent=it.sub;
        if(shop){shop.href=it.url;} if(mcta){mcta.href=it.url;}
        if(mchips){mchips.innerHTML=it.specs.map(function(s){return '<span><i><svg width="10" height="10" viewBox="0 0 18 18"><path d="M3.5 9.5l3.5 3.5 7.5-8" fill="none" stroke="#0a0a0c" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></i>'+s.replace(/</g,'&lt;')+'</span>';}).join('');}
        info.classList.remove('swap');info.classList.add('enter');void info.offsetWidth;info.classList.remove('enter');
        if(mchips) setTimeout(function(){mchips.classList.add('on');},120);
      },prev<0?0:220);
    }
    function now(){return performance.now()/1000;}
    function manual(i,hold){cur=i;pauseUntil=performance.now()+(hold||5000);lastTour=performance.now();}

    function frame(ts){
      raf=0;
      var dt=Math.min(0.05,last?(ts-last)/1000:0.016);last=ts;var t=ts/1000;
      if(revealed&&AUTO&&hover<0&&!editorHold&&ts>pauseUntil&&ts-lastTour>INT){cur=(cur+1)%items.length;lastTour=ts;}
      var active=hover>=0?hover:cur;
      setActive(revealed?active:-1);
      var L=0;
      items.forEach(function(it,i){
        var tgt=(i===shown)?1:0;
        if(RM){it.f=tgt;it.fv=0;}else{it.fv+=((tgt-it.f)*170-it.fv*21)*dt;it.f+=it.fv*dt;}
        L=Math.max(L,cl(it.f));
        it.av+=(-55*it.a-4.2*it.av)*dt;it.a+=it.av*dt;
      });
      if(!mobile&&mx>=0&&!RM){var vx=mvx;mvx*=0.8;items.forEach(function(it){var d=Math.abs(it.x-mx);if(d<sp*1.3&&my>railY-30&&my<railY+gw*1.6){it.av+=vx*0.012*(1-d/(sp*1.3));}});}
      if(mobile){var tx=shown>=0?items[shown].x:items[0].x;camX+=(tx-camX)*Math.min(1,dt*(RM?60:5.5));}
      var off=mobile?W/2-camX:0;
      track.style.transform='translate3d('+off+'px,0,0)';
      items.forEach(function(it,i){
        var f=it.f,y=0,op=1;
        if(!revealed){op=0;}else{
          var td=t-it.dropAt;
          if(RM){y=0;}else if(td<0){op=0;y=-(railY+gw*2);}else{y=-(railY+gw*2)*(1-eOC(cl(td/0.6)));if(!it.landed&&td>=0.6){it.landed=true;it.av+=(i%2?1:-1)*80;}}
        }
        var dx=edgeShift(it)*cl(f,0,1.2);items.forEach(function(o,j){if(j===i)return;var d=Math.abs(i-j);var amt=d===1?gw*0.45:d===2?gw*0.17:0;if(amt)dx+=cl(o.f,0,1.2)*amt*(i>j?1:-1);});
        var tf=t-it.featT,ry=(!RM&&tf>0&&tf<4)?20*Math.exp(-2*tf)*Math.sin(6*tf)*cl(f):0;
        var idle=RM?0:0.7*Math.sin(1.3*t+i*1.7);
        var sc=1+(S-1)*f;
        it.el.style.opacity=op;
        it.el.style.transform='translate3d('+(it.x-gw/2+dx)+'px,'+(railY+y)+'px,0)';
        it.el.style.zIndex=f>0.02?(50):(20-Math.abs(i-(shown>=0?shown:0)));
        it.sw.style.transform='rotate('+(it.a+idle).toFixed(2)+'deg) perspective(1100px) rotateY('+ry.toFixed(2)+'deg) scale('+sc.toFixed(4)+')';
        var other=L*(1-cl(f));
        var fs=(f>0.03?'drop-shadow(0 '+Math.round(26*f)+'px '+Math.round(34*f)+'px rgba(0,0,0,.6)) ':'')+'brightness('+(1-0.6*other+0.05*cl(f)).toFixed(3)+')'+(other>0.02?' blur('+(2.6*other).toFixed(2)+'px)':'');
        if(it.img&&fs!==it.lastF){it.img.style.filter=fs;it.lastF=fs;}
      });
      var ax=shown>=0?items[shown].x+off+edgeShift(items[shown])*cl(items[shown].f):W/2;
      cone.style.transform='translate3d('+ax+'px,0,0)';cone.style.opacity=(L*0.95).toFixed(3);
      var gc=shown>=0?items[shown].glow:[58,65,80];
      for(var k=0;k<3;k++) glowC[k]+=(gc[k]-glowC[k])*Math.min(1,dt*3);
      glow.style.background='radial-gradient(ellipse 46% 58% at '+ax+'px '+(railY+gw*S*0.6)+'px,rgba('+glowC.map(Math.round).join(',')+',.55) 0%,rgba('+glowC.map(Math.round).join(',')+',.16) 45%,transparent 75%),linear-gradient(180deg,#0e0f13,#060607)';
      if(water) water.style.transform='translate3d('+(mobile?(-camX*0.3-200):(-(mx>=0?mx:W/2)*0.06-200))+'px,0,0)';
      if(!mobile&&shown>=0){
        var it=items[shown],s=1+(S-1)*it.f,cx=it.x+off+edgeShift(it)*cl(it.f,0,1.2),top=railY+hookOff*s,gh=gw*it.ar*s,half=gw*s/2;
        var leftRoom=cx-half, rightRoom=W-(cx+half);
        var fr=[[0.38,0.22],[0.34,0.47],[0.36,0.72]];
        calls.forEach(function(c,k){
          if(!c.w) return;
          var side=(k===1)?1:-1;
          var need=c.w+56;
          if(side<0&&leftRoom<need&&rightRoom>=need) side=1; else if(side>0&&rightRoom<need&&leftRoom>=need) side=-1;
          var axp=cx+side*half*fr[k][0], ayp=top+gh*fr[k][1];
          var cy=ayp+[-46,22,30][k];
          var chipX=side<0?Math.max(16,leftRoom-c.w-36-k%2*10):Math.min(W-16-c.w,cx+half+36);
          var ex=side<0?chipX+c.w:chipX, ey=cy+c.h/2;
          var dxl=ex-axp,dyl=ey-ayp,len=Math.hypot(dxl,dyl),ang=Math.atan2(dyl,dxl);
          c.line.style.left=axp+'px';c.line.style.top=(ayp-1)+'px';c.line.style.width=len+'px';c.line.style.rotate=ang+'rad';
          c.dot.style.left=axp+'px';c.dot.style.top=ayp+'px';
          c.chip.style.left=chipX+'px';c.chip.style.top=cy+'px';c.chip.style.transformOrigin=side<0?'100% 50%':'0 50%';
        });
      }
      if(visible) raf=requestAnimationFrame(frame);
    }
    function kick(){if(!raf&&visible){last=0;raf=requestAnimationFrame(frame);}}
    function reveal(){
      if(revealed) return;revealed=true;root.classList.add('is-in');
      var t=now()+0.35;
      var order=items.map(function(it,i){return i;});
      if(!mobile){var c=(items.length-1)/2;order.sort(function(a,b){return Math.abs(a-c)-Math.abs(b-c);});}
      order.forEach(function(idx,k){items[idx].dropAt=t+k*0.07;});
      lastTour=performance.now()+(RM?0:1400)-INT;
      if(!AUTO){cur=0;}
    }
    function onMove(e){
      if(mobile) return;var r=root.getBoundingClientRect();var x=e.clientX-r.left,y=e.clientY-r.top;
      if(pmx>=0) mvx=x-pmx;pmx=x;mx=x;my=y;
      if(!revealed) return;
      var el=document.elementFromPoint(e.clientX,e.clientY);var a=el&&el.closest?el.closest('.prh__item'):null;
      var idx=-1;if(a){for(var k=0;k<items.length;k++){if(items[k].el===a){idx=k;break;}}}
      if(idx>=0){hover=idx;}
      else if(y<railY-24||y>railY+(hookOff+gw*1.45)*S){if(hover>=0){cur=hover;lastTour=performance.now();}hover=-1;}
      kick();
    }
    function onLeave(){if(hover>=0){cur=hover;lastTour=performance.now();}hover=-1;mx=-1;pmx=-1;}
    stage.addEventListener('mousemove',onMove);stage.addEventListener('mouseleave',onLeave);
    var sx=0,sy=0,moved=false;
    stage.addEventListener('touchstart',function(e){var p=e.touches[0];sx=p.clientX;sy=p.clientY;moved=false;},{passive:true});
    stage.addEventListener('touchmove',function(e){var p=e.touches[0];if(Math.abs(p.clientX-sx)>12&&Math.abs(p.clientX-sx)>Math.abs(p.clientY-sy))moved=true;},{passive:true});
    stage.addEventListener('touchend',function(e){var p=e.changedTouches[0];var dx=p.clientX-sx;if(moved&&Math.abs(dx)>40){var base=shown>=0?shown:0;manual((base+(dx<0?1:-1)+items.length)%items.length,6000);kick();}},{passive:true});
    items.forEach(function(it,i){
      it.el.addEventListener('click',function(e){
        if(moved){e.preventDefault();moved=false;return;}
        if(mobile&&i!==shown){e.preventDefault();manual(i,6000);kick();}
        if(it.url==='#'||!it.url){e.preventDefault();}
      });
      it.el.addEventListener('focus',function(){manual(i,8000);kick();});
    });
    var io=new IntersectionObserver(function(en){en.forEach(function(e){visible=e.isIntersecting;if(visible){if(!revealed){layout();reveal();}kick();}});},{threshold:0.15});
    io.observe(root);
    var ro=window.ResizeObserver?new ResizeObserver(function(){layout();kick();}):null;if(ro)ro.observe(root);else window.addEventListener('resize',layout);
    layout();
    self.select=function(i){editorHold=true;if(!revealed)reveal();cur=i;hover=-1;kick();};
    self.release=function(){editorHold=false;lastTour=performance.now();};
    self.destroy=function(){io.disconnect();if(ro)ro.disconnect();cancelAnimationFrame(raf);visible=false;};
    root.__prh=self;
  }
  function scan(){[].forEach.call(document.querySelectorAll('.prh'),function(r){if(!r.__prh)new Rail(r);});}
  window.__PRH_SCAN__=scan;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.prh');if(r){if(r.__prh)r.__prh.destroy();r.__prh=null;new Rail(r);}});
  document.addEventListener('shopify:section:unload',function(e){var r=e.target.querySelector('.prh');if(r&&r.__prh)r.__prh.destroy();});
  document.addEventListener('shopify:block:select',function(e){var r=e.target.closest('.prh');if(r&&r.__prh){var els=[].slice.call(r.querySelectorAll('.prh__item'));r.__prh.select(els.indexOf(e.target));}});
  document.addEventListener('shopify:block:deselect',function(e){var r=e.target.closest('.prh');if(r&&r.__prh)r.__prh.release();});
})();
